import { motion } from "framer-motion";
import { AlertCircle, CheckCircle2, Clock, Zap } from "lucide-react";

const stateConfig = {
  enviado: { label: "Recibido", color: "bg-blue-100 text-blue-700", icon: AlertCircle },
  clasificado: { label: "Clasificado", color: "bg-purple-100 text-purple-700", icon: Clock },
  asignado: { label: "Asignado", color: "bg-yellow-100 text-yellow-700", icon: Zap },
  en_proceso: { label: "En proceso", color: "bg-orange-100 text-orange-700", icon: Clock },
  resuelto: { label: "Resuelto", color: "bg-green-100 text-green-700", icon: CheckCircle2 },
  cerrado: { label: "Cerrado", color: "bg-gray-100 text-gray-700", icon: CheckCircle2 }
};

export default function StatusBadge({ estado, className = "" }) {
  const config = stateConfig[estado] || stateConfig["enviado"];
  const Icon = config.icon;

  return (
    <motion.div
      initial={{ scale: 0.9, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-sm font-medium ${config.color} ${className}`}
    >
      <Icon size={16} />
      {config.label}
    </motion.div>
  );
}
